import React, { useEffect, useState } from 'react'
import SideModal from '../SideModal/SideModal'
import { Button, Form } from 'react-bootstrap'
import Loader from '../Loader/Loader.index';
import Select from 'react-select'
import InvoiceService from '../../services/invoice.service';
import toast from 'react-hot-toast';

export const InvoiceType = {
    INDIA: "India",
    INTERNATIONAL: "International",
    INTERNATIONAL_MT: "Music Therapy International",
    INDIA_MT: "Music Therapy India",
}

interface IProps {
    show: boolean,
    onClose: any,
    invoice: any, 
    invoiceType: any,
}

const RecreateInvoicePdfModal = ({ show, onClose, invoice, invoiceType }: IProps) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [invoiceNumber, setInvoiceNumber] = useState<any>(invoice);
    const [type, setType] = useState<any>({ value: invoiceType, label: invoiceType });


    useEffect(()=>{
        setInvoiceNumber(invoice);
        setType({ value: invoiceType, label: invoiceType });
    },[invoice, invoiceType]);

    const recreateInvoicePdf = async () => {
        setLoading(true);
        if (!invoiceNumber || invoiceNumber.length <= 0) {
            toast.error("Invoice Number is required");
            return;
        }
        if (!type || type.length <= 0) {
            toast.error("Invoice type is required");
            return;
        }
        await InvoiceService.recreateInvoiceByInvoiceNumber({ invoice: invoiceNumber, type: type.label }).then((res) => {
            if (res.status == 200) {
                toast.success("Invoice pdf created");
                onClose();
            }
        })
            .catch((error) => {
                console.log(error);
                toast.error("Unable to create pdf");
                onClose();
            })
        setLoading(false);
    }

    return (
        <SideModal
            title="Recreate Invoice"
            show={show ? true : false}
            handleClose={onClose}
            body={
                <>
                    <div style={{ height: "80vh" }}>
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold text-secondary">Invoice Number: </Form.Label>
                            <div className=''>
                                {invoiceNumber}
                            </div>
                        </Form.Group>
                        <Form.Group className="mb-3 ">
                            <Form.Label className="fw-bold text-secondary">Invoice Type:</Form.Label>
                            <div className=''>
                                {type.label}
                            </div>
                        </Form.Group>
                    </div>
                    <div>
                        <Button className='w-100' disabled={loading ? true : false} onClick={() => { recreateInvoicePdf() }}>
                            {loading ? "Creating..." : "Create Invoice"}
                        </Button>
                    </div>
                </>
            }
        />
    )
}

export default RecreateInvoicePdfModal